import AboutHeroSection from '../components/AboutUs/AboutHeroSection';
import OurStorySection from '../components/AboutUs/OurStorySection';
import WhoAreWeSection from '../components/AboutUs/WhoAreWeSection';
import TeamStatsSection from '../components/AboutUs/TeamStatsSection';
import TeamCarouselSection from '../components/AboutUs/TeamCarouselSection';
import OurValuesSection from '../components/AboutUs/OurValuesSection';
import Silk from '../components/SilkBackground';

function AboutUs() {
  return (
    <>
      <div className="fixed inset-0 -z-10 pointer-events-none">
        <Silk speed={10} scale={1} color="#e3c8b3" noiseIntensity={1.5} rotation={0} />
      </div>

      {/* Page wrapper: full-bleed white and offset for fixed navbar */}
      <main className="min-h-screen bg-white pt-20 md:pt-24"> 
        {/* Hero Section */}
        <AboutHeroSection />

        {/* Our Story Section */}
        <OurStorySection />

        {/* Who We Are Section */}
        <WhoAreWeSection />

        {/* Team Stats Section */}
        <TeamStatsSection />

        {/* Our Values Section */}
        <OurValuesSection />
      </main>
    </>
  );
}


export default AboutUs;
  